
export default {
  name: "EnvioContabilidadeItensEnvioChecklist",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    itens: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isSelecionado(key) {
      return Boolean(this.value && this.value[key]);
    },
    alterar(key, checked) {
      this.$emit("input", {
        ...(this.value || {}),
        [key]: Boolean(checked),
      });
    },
  },
};
